import { render, staticRenderFns } from "./SelectAvatar.vue?vue&type=template&id=1159e1b0&scoped=true"
import script from "./SelectAvatar.vue?vue&type=script&lang=js"
export * from "./SelectAvatar.vue?vue&type=script&lang=js"
import style0 from "./SelectAvatar.vue?vue&type=style&index=0&id=1159e1b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1159e1b0",
  null
  
)

export default component.exports